import * as React from 'react';
import { Check } from 'lucide-react';

import { cn } from '@shared/utils/cn';

type Props = {
  steps: string[];
  /** Index of the current step (`steps.length` = everything is done) */
  activeStep: number;
  'aria-label'?: string;
  className?: string;
};

/** Vertical stepper (remplace `Stepper` de MUI) : étapes terminées cochées, étape courante mise en avant. */
const Stepper = ({ steps, activeStep, className, ...props }: Props) => (
  <ol aria-label={props['aria-label']} className={cn('flex flex-col', className)} data-slot="stepper">
    {steps.map((label, index) => {
      const done = index < activeStep;
      const active = index === activeStep;

      return (
        <li aria-current={active ? 'step' : undefined} className="flex gap-3" key={label}>
          <div className="flex flex-col items-center">
            <span
              className={cn(
                'flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-bold',
                done || active ? 'bg-primary text-primary-foreground' : 'bg-muted-foreground/24 text-muted-foreground'
              )}
            >
              {done ? <Check className="size-3.5 stroke-3" /> : index + 1}
            </span>
            {index < steps.length - 1 && (
              <span className={cn('my-1 min-h-4 w-px grow', done ? 'bg-primary' : 'bg-border')} />
            )}
          </div>
          <span
            className={cn(
              'pb-4 text-sm leading-6',
              active ? 'font-bold text-foreground' : done ? 'font-medium text-foreground' : 'text-muted-foreground'
            )}
          >
            {label}
          </span>
        </li>
      );
    })}
  </ol>
);

export { Stepper };
